// extracted by mini-css-extract-plugin
export default {"container":"Wv","content":"Xv","btn":"Yv","left":"Zv","head":"aw","subHead":"bw"};
    if(module.hot) {
      // 1713211512945
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  